import type { ISODate } from "@inrev/common";
import { DateTime } from "luxon";

export const isPriorPeriodOnStatement = (
	periodEndDate: ISODate | undefined,
	sourceStatementDate: ISODate | undefined,
): boolean => {
	if (!periodEndDate || !sourceStatementDate) {
		return false;
	}
	return DateTime.fromISO(periodEndDate) < DateTime.fromISO(sourceStatementDate);
};
